//export const BASE_URL = "http://localhost:3001/";
const BASE_URL = process.env.REACT_APP_BACKEND_URL;


export const USERS = `${BASE_URL}api/users` 

export const CLIENTES = `${BASE_URL}api/clientes`

export const DOCUMENTS = `${BASE_URL}api/documents`

export const DOCUMENTS_IN = `${BASE_URL}api/documentsIn`

export const ITEMS = `${BASE_URL}api/items`

export const LOGIN = `${BASE_URL}api/auth`

export const PRESUPUESTO = `${BASE_URL}api/presupuesto`

